module.exports = __webpack_public_path__ + "static/3.2moveCameraRight-7f367e57d87ff0ae60f34c2f98fb8253.gif";